import React, { useEffect } from "react";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationState } from "../store";
import { useState } from "react";
import { shouldShowStickyPriceButton } from "../helpers/shouldShowStickyPriceButton";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  circular: {
    color: "#FAFAFA",
  },
  stickyBackdrop: {
    backgroundColor: "transparent",
    pointerEvents: "auto",
  },
  stickyCircular: {
    display: "none",
  },
}));

const Progress: React.FC<ProgressProps> = (props: ProgressProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const active = props.processing ?? false;
  const isCheckoutPage = localStorage.getItem("Webshop Page") === "Checkout";
  const hideForStickyPriceButton = props.showStickyPriceButton && !isCheckoutPage;

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setIsOpen(active);
      },
      active ? 500 : 250,
    );
    return () => clearTimeout(timer);
  }, [active]);

  const css = useStyles();
  return (
    <Backdrop id='progress_backdrop' className={`${css.backdrop} ${hideForStickyPriceButton ? css.stickyBackdrop : ""}`} open={isOpen}>
      <CircularProgress id='progress_circular' className={`${css.circular} ${hideForStickyPriceButton ? css.stickyCircular : ""}`} />
    </Backdrop>
  );
};

const connector = connect((state: ApplicationState) => ({
  ...state.ui,
  showStickyPriceButton:
    state.ui.initialized && !state.dealerPrice?.IsDealerPrice && shouldShowStickyPriceButton(state.inputs?.partner),
}), {});

type ProgressProps = ConnectedProps<typeof connector>;

export default connector(Progress);
